import { httpGet, httpPost, httpDelete } from "@/request/http";

let path = "/customCategoryItems";

export default {
  get(categoryId) {
    return httpGet(`${path}/${categoryId}`);
  },
  postFoods(item) {
    return httpPost(`${path}/addbatch`, item);
  },
  removeFoods(item) {
    return httpPost(`${path}/deletebatch`, item);
  },
  remove(id) {
    return httpDelete(`${path}/${id}`);
  },
  sequence(item) {
    return httpPost(`${path}/priority/position`, item);
  },
};
